import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import CountdownNow from 'react-countdown-now';
import styled from 'styled-components';
var numberFontSize = '2.71em';
var Container = styled.div.withConfig({
  displayName: "Countdown__Container",
  componentId: "sc-1r4whuh-0"
})(["\n  align-items: stretch;\n  display: flex;\n  flex-direction: row;\n"]);
var CountdownBlockContainer = styled.div.withConfig({
  displayName: "Countdown__CountdownBlockContainer",
  componentId: "sc-1r4whuh-1"
})(["\n  display: flex;\n  flex-direction: row;\n"]);
var CountContainer = styled.div.withConfig({
  displayName: "Countdown__CountContainer",
  componentId: "sc-1r4whuh-2"
})(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 3em;\n  text-align: center;\n"]);
var CountdownNumber = styled.span.withConfig({
  displayName: "Countdown__CountdownNumber",
  componentId: "sc-1r4whuh-3"
})(["\n  font-size: ", ";\n  font-weight: bold;\n"], numberFontSize);
var CountdownLabel = styled.span.withConfig({
  displayName: "Countdown__CountdownLabel",
  componentId: "sc-1r4whuh-4"
})(["\n  font-size: 0.57em;\n"]);
var Separator = styled.span.withConfig({
  displayName: "Countdown__Separator",
  componentId: "sc-1r4whuh-5"
})(["\n  font-size: ", ";\n  padding: 0 0.4em;\n"], numberFontSize);

var CountdownBlock = function CountdownBlock(_ref) {
  var addSeparator = _ref.addSeparator,
      count = _ref.count,
      label = _ref.label;
  return count ? React.createElement(CountdownBlockContainer, null, React.createElement(CountContainer, null, React.createElement(CountdownNumber, null, count), React.createElement(CountdownLabel, null, label)), addSeparator && React.createElement(Separator, null, ":")) : null;
};

var renderCountdown = function renderCountdown(_ref2) {
  var days = _ref2.days,
      hours = _ref2.hours,
      minutes = _ref2.minutes,
      seconds = _ref2.seconds,
      labels = _ref2.labels,
      className = _ref2.className;
  // Countdown component won't 0-pad days for us automatically, and we
  // should also hide the days section altogether if 0.
  var paddedDays = days ? days < 10 ? "0" + days : "" + days : '';
  return React.createElement(Container, {
    className: className
  }, React.createElement(CountdownBlock, {
    addSeparator: true,
    count: paddedDays,
    label: labels.days
  }), React.createElement(CountdownBlock, {
    addSeparator: true,
    count: hours,
    label: labels.hours
  }), React.createElement(CountdownBlock, {
    addSeparator: true,
    count: minutes,
    label: labels.minutes
  }), React.createElement(CountdownBlock, {
    count: seconds,
    label: labels.seconds
  }));
};

var Countdown = function Countdown(_ref3) {
  var className = _ref3.className,
      date = _ref3.date,
      labels = _ref3.labels,
      rest = _objectWithoutPropertiesLoose(_ref3, ["className", "date", "labels"]);

  return React.createElement(CountdownNow, _extends({
    className: className,
    date: date,
    renderer: renderCountdown,
    labels: labels
  }, rest));
};

Countdown.defaultProps = {
  labels: {
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  }
};
Countdown.propTypes = _objectSpread({
  labels: PropTypes.object,
  className: PropTypes.string
}, CountdownNow.propTypes);
Countdown.CountdownLabel = CountdownLabel;
Countdown.CountdownNumber = CountdownNumber;
export default Countdown;